export default __webpack_public_path__ + "static/media/iconHomeNewsActive.93c2bd0a.svg";